require("./heatmap/HeatmapSeries");

require("./heatmap/HeatmapView");


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/chart/heatmap.js
// module id = 2061
// module chunks = 1